export const CHOOSE_SERVICES = "choose_services";

export const FILL_PATIENT_INFO = "fill_patient_info";

export const FILL_APPOINTMENT_INFO = "fill_appointment_info";

export const CONFIRM_APPOINTMENTS = "confirm_appointments";
